import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'svg-lien-externe',
    templateUrl: './lien-externe.component.svg',
    styleUrls: ['./lien-externe.component.scss'],
    imports: [
        TranslateModule
    ]
})
export class LienExterneComponent {

}
